import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppLanguage = 'en' | 'ru';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly storageKey = 'language';

  private readonly languageSubject = new BehaviorSubject<AppLanguage>(
    this.getInitialLanguage()
  );

  language$ = this.languageSubject.asObservable();

  get currentLanguage(): AppLanguage {
    return this.languageSubject.value;
  }

  get currentIndex(): number {
    return this.currentLanguage === 'en' ? 0 : 1;
  }

  setLanguage(language: AppLanguage): void {
    localStorage.setItem(this.storageKey, language);
    this.languageSubject.next(language);
  }

  toggleLanguage(): void {
    this.setLanguage(this.currentLanguage === 'en' ? 'ru' : 'en');
  }

  translate(texts: string[] | string): string {
    if (typeof texts === 'string') {
      return texts;
    }

    return texts[this.currentIndex] ?? texts[0] ?? '';
  }

  private getInitialLanguage(): AppLanguage {
    const saved = localStorage.getItem(this.storageKey);

    if (saved === 'en' || saved === 'ru') {
      return saved;
    }

    const browserLanguage = navigator.language.toLowerCase();

    if (browserLanguage.startsWith('ru')) {
      return 'ru';
    }

    return 'en';
  }
}
